import { CapacityUnitLabels, CapacityUnitShortLabels, Equipment } from '@alliance-disposal/transport-types';
export const getContainerTypeName = (containerType) => {
    if (!containerType)
        return 'Equipment';
    if (containerType.style === 'ROLL_OFF') {
        return `${containerType.capacity} ${CapacityUnitShortLabels[containerType.capacityUnit].toUpperCase()} ${Equipment.RollOffVariantLabels[containerType.rollOffVariant]} ${containerType.name?.trim() ? ` (${containerType.name})` : ''}`;
    }
    return containerType.capacity === 0 // check for loose container type
        ? 'Loose'
        : `${Equipment.ContainerTypeLabels[containerType.style]} - ${containerType.capacity} ${CapacityUnitLabels[containerType.capacityUnit]}${containerType.name?.trim() ? ` (${containerType.name})` : ''}`;
};
//# sourceMappingURL=container-formatter.js.map